import { useState, useEffect } from "react";
import { usePapaParse } from "react-papaparse";
import Link from "components/_ui/Link/Link";
import classNames from "classnames";
import ReactGA from "react-ga";
import BannerMessage from "components/_ui/BannerMessage/BannerMessage";
import DvsIcon from "components/_ui/DvsIcon/DvsIcon";
import DVSMapContainer from "components/DVS/DVSMap/DVSMapContainer";
import Spinner from "components/_ui/Spinner/Spinner";
import Label from "components/_ui/Label/Label";
import data from "./dvs_challenge_1_membership_time_space.csv";

import "./DVS.scss";

const colors = [
    {
        name: "data",
        color: "#29B6A8",
    },
    {
        name: "visualization",
        color: "#F4AE05",
    },
    {
        name: "society",
        color: "#9769F8",
    },
];

export default function DVS() {
    const [data, setData] = useState([]);
    const [isLoaded, setIsLoaded] = useState(false);
    const [userTopOffset, setUerTopOffset] = useState(0);
    const [userLeftOffset, setUserLeftOffset] = useState(0);
    const [showMe, setShouldShowMe] = useState(true);
    const [showMap, setShouldShowMap] = useState(true);

    const [filterOptions, setFilterOptions] = useState([
        "data",
        "visualization",
        "society",
        "me",
        "map",
    ]);

    const { readRemoteFile } = usePapaParse();

    const toggleData = (name) => {
        console.log(filterOptions);

        if (filterOptions.includes(name)) {
            console.log(name);
            let filters = [...filterOptions];
            filters.splice(filters.indexOf(name), 1);
            setFilterOptions(filters);
        } else {
            setFilterOptions([...filterOptions, name]);
        }
    };

    const trackEvent = (action) => {
        ReactGA.event({
            category: "User",
            action: action,
        });
    };

    const setUserOffsets = (top, left) => {
        this.setState({ userTopOffset: top, userLeftOffset: left });
    };

    useEffect(() => {
        function fetchData() {
            readRemoteFile("./dvs_challenge_1_membership_time_space.csv", {
                download: true,
                complete: (results) => {
                    setData(results.data);
                    setIsLoaded(true);
                },
            });
        }

        fetchData();
    }, []);

    return (
        <div className="DVSPage SinglePage">
            <BannerMessage reason="archived" github="https://github.com/margueriteroth/rosie-archive/blob/main/src/components/DVS/DVS.jsx" />
            {isLoaded && (
                <div className="DVSContainer">
                    <div className="DVS__section DVS__section--info">
                        <div className="DVS__credential">
                            <div className="DVS__icon">
                                <DvsIcon />
                            </div>
                            <Link to="https://marguerite.io/" className="DVS__link">
                                <Label category="primary">
                                    ← Marguerite.io
                                </Label>
                            </Link>
                        </div>

                        <h1>Data Visualization Society</h1>
                        <p>
                            This map shows the locations of{" "}
                            <a
                                rel="noopener noreferrer"
                                target="_blank"
                                href="https://www.datavisualizationsociety.com/"
                            >
                                DVS
                            </a>{" "}
                            sign-ups between February 20, 2019 and March 9,
                            2019.
                        </p>
                        <div className="DVS__InfoKey">
                            <p>
                                Each member was asked to rank their skills in
                                the following categories: <strong>data</strong>,{" "}
                                <strong>visualization</strong>, and{" "}
                                <strong>society</strong>. The color represents
                                the member's highest ranked skill.
                            </p>
                            <div className="DVS__key__container">
                                {colors.map((color, key) => (
                                    <div
                                        key={key}
                                        className={classNames("DVS__key", {
                                            "DVS__key--inactive":
                                                !filterOptions.includes(
                                                    color.name
                                                ),
                                        })}
                                        onClick={() => toggleData(color.name)}
                                    >
                                        <span
                                            className="DVS__key__color"
                                            style={{ background: color.color }}
                                        ></span>
                                        <span
                                            className="DVS__key__color"
                                            style={{ background: color.color }}
                                        ></span>
                                        <Label className="DVS__key__label">
                                            {color.name}
                                        </Label>
                                    </div>
                                ))}

                                <div
                                    className={classNames("DVS__key", {
                                        "DVS__key--inactive":
                                            !filterOptions.includes("map"),
                                    })}
                                    onClick={() => toggleData("map")}
                                >
                                    <span className="DVS__key__color DVS__key__color--map"></span>
                                    <Label className="DVS__key__label">
                                        Map
                                    </Label>
                                </div>
                                <div
                                    className={classNames("DVS__key", {
                                        "DVS__key--inactive":
                                            !filterOptions.includes("me"),
                                    })}
                                    onClick={() => toggleData("me")}
                                >
                                    <Spinner className="DVS__key__spooch" />
                                    <Label className="DVS__key__label">
                                        You
                                    </Label>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="DVS__section DVS__section--map">
                        <DVSMapContainer
                            dvsData={data}
                            setLoading={setIsLoaded}
                            showMap={filterOptions.includes("map")}
                            showMe={filterOptions.includes("me")}
                            showData={filterOptions.includes("data")}
                            showViz={filterOptions.includes("visualization")}
                            showSociety={filterOptions.includes("society")}
                        />
                    </div>
                </div>
            )}
        </div>
    );
}
